import { __ } from '@wordpress/i18n';
import { InspectorControls} from '@wordpress/block-editor';
import Style from './style';
import Icon from './icon';
import {VayuBlocksHeaderTab,usePanelSettings } from '@vayu-blocks';
import {VayuBlocksAdvancePanel} from '@vayu-blocks/advance-panel';

const panelKeys = [
	'slide-layout',
	'slide-title',
	'slide-text',
	'slide-animation',
	'overlay-icon',
	'overlay-border',
];

const initialPanels = {
	slide: 'slide-layout',
	style: '',
	advanced: '',
};

const panelOptions  = [
	{ label: __( 'Icon', 'vayu-blocks' ), value: 'slide', icon: 'slide'},
	{ label: __( 'Style', 'vayu-blocks' ), value: 'style', icon: 'diamond'},
	{ label: __( 'Advanced', 'vayu-blocks' ), value: 'advanced', icon: 'colorpalette'}
];

const PanelSettings = ({attributes,setAttributes,isSelected,clientId}) => {
    
	const { tab, setTab, openPanels, onTogglePanel } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'slide' });

	const tabComponents = {
		slide: <Icon attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		style: <Style attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		advanced: <VayuBlocksAdvancePanel attributes={attributes} setAttributes={setAttributes} clientId={clientId} video={true} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
	};

    return (
		<>
			{isSelected && (
				<InspectorControls>
					<div className='th-block-ins th-button-panel'>

						<VayuBlocksHeaderTab 
							value={ tab }
							options={panelOptions}
							onChange={ setTab }
						/>

						{tabComponents[tab]}

					</div>
				</InspectorControls>  
			)}

    	</>
	);
}

export default PanelSettings;